(async function () {
  try {
    // ดึงประเทศจาก IP (Shopify)
    const res = await fetch('/browsing_context_suggestions.json', {
      credentials: 'same-origin'
    });
    const data = await res.json();

    const ipCountry = data.detected_values?.country?.handle;
    if (!ipCountry) return;

    // country ที่กำลังใช้อยู่ (จาก URL)
    const urlParams = new URLSearchParams(window.location.search);
    const urlCountry = urlParams.get('country');

    // cookie country (ถ้ามี)
    const cookieCountry = document.cookie
      .split('; ')
      .find(row => row.startsWith('_shopify_country='))?.split('=')[1];

    // ถ้า IP ≠ current market → บังคับ switch
    if (ipCountry !== cookieCountry && ipCountry !== urlCountry) {
      // ล้าง cookie เก่า
      document.cookie = `_shopify_country=; path=/; max-age=0`;
      document.cookie = `_shopify_market=; path=/; max-age=0`;

      // redirect พร้อม country param (ตัวนี้คือ KEY)
      const url = new URL(window.location.href);
      url.searchParams.set('country', ipCountry.toUpperCase());
      window.location.replace(url.toString());
    }

  } catch (e) {
    console.warn('Market switch skipped:', e);
  }
})();
